import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  templateUrl: './simple-modal.component.html'
})

export class SimpleModalComponent {
  @Input() message;

  constructor(public activeModal: NgbActiveModal) { }
}
